import { render, staticRenderFns } from "./RiskDetail.vue?vue&type=template&id=7c29c4ce&scoped=true"
import script from "./RiskDetail.vue?vue&type=script&lang=js"
export * from "./RiskDetail.vue?vue&type=script&lang=js"
import style0 from "./RiskDetail.vue?vue&type=style&index=0&id=7c29c4ce&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c29c4ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c29c4ce')) {
      api.createRecord('7c29c4ce', component.options)
    } else {
      api.reload('7c29c4ce', component.options)
    }
    module.hot.accept("./RiskDetail.vue?vue&type=template&id=7c29c4ce&scoped=true", function () {
      api.rerender('7c29c4ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/new-column/column-m/form/RiskDetail.vue"
export default component.exports